import * as React from 'react';

import { Link } from 'react-router';
import { IOwner } from '../../types';
import { url, safeJsonParse, createFetchOptions } from '../../util';

import OwnerInformation from './OwnerInformation';
import PetsTable from './PetsTable';
import BackButton from '../common/BackButton';

interface IOwnersPageProps {
  params?: { ownerId?: string };
}

interface IOwnerPageState {
  owner?: IOwner;
  loading?: boolean;
  error?: string;
}

export default class OwnersPage extends React.Component<IOwnersPageProps, IOwnerPageState> {
  private _isMounted: boolean = false;

  constructor(props?: IOwnersPageProps) {
    super(props);

    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadOwner();
  }

  componentWillReceiveProps(nextProps: IOwnersPageProps) {
    // Reload owner when route params change
    const currentOwnerId = this.props.params && this.props.params.ownerId;
    const nextOwnerId = nextProps.params && nextProps.params.ownerId;
    if (nextOwnerId && nextOwnerId !== currentOwnerId) {
      this.loadOwner();
    }
  }

  loadOwner() {
    const { params } = this.props;

    if (params && params.ownerId) {
      this.setState({ loading: true, error: undefined });
      const fetchUrl = url(`/api/owners/${params.ownerId}`);
      console.log('Fetching owner from:', fetchUrl);
      fetch(fetchUrl, createFetchOptions())
        .then(response => {
          console.log('Owner fetch response status:', response.status);
          if (response.status === 404) {
            throw new Error('Owner not found');
          }
          if (response.status >= 400) {
            throw new Error(`Failed to load owner: HTTP ${response.status}`);
          }
          return safeJsonParse(response);
        })
        .then(owner => {
          console.log('Owner data received:', owner);
          if (this._isMounted) {
            this.setState({ owner, loading: false, error: undefined });
          }
        })
        .catch(error => {
          console.error('Error loading owner:', error);
          if (this._isMounted) {
            this.setState({ 
              owner: undefined, 
              loading: false, 
              error: error.message || 'Failed to load owner details' 
            });
          }
        });
    } else {
      this.setState({ loading: false, error: 'No owner ID provided' });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { owner, loading, error } = this.state;

    if (loading) {
      return <div><h2>Loading owner details...</h2></div>;
    }

    if (error) {
      return (
        <div>
          <h2>Error</h2>
          <p className="text-danger">{error}</p>
        </div>
      );
    }

    if (!owner) {
      return <h2>No Owner loaded</h2>;
    }

    return (
      <span>
        <BackButton />
        <OwnerInformation owner={owner} />
        <PetsTable owner={owner} />
      </span>
    );
  }
}
